import { Button } from "@/components/ui";
import { FileText, X } from "lucide-react";
import { formatFileSize } from "./utils";

interface AttachmentButtonProps {
  name: string;
  size: number;
  onClick: () => void;
  onRemove?: () => void;
  variant?: "compact" | "removable";
  className?: string;
}

export function AttachmentButton({
  name,
  size,
  onClick,
  onRemove,
  variant = "compact",
  className = "",
}: AttachmentButtonProps) {
  const formattedSize = formatFileSize(size);

  if (variant === "removable") {
    return (
      <div
        className={`flex pl-1 gap-1 items-center border border-border rounded-md bg-card ${className}`}
      >
        <button
          type="button"
          className="flex items-center gap-1 min-w-0 cursor-pointer"
          onClick={onClick}
          title={`Click to preview ${name}`}
        >
          <FileText className="h-3 w-3 text-muted-foreground" />
          <span className="text-xs font-medium truncate">{name}</span>
          <span className="text-xs text-muted-foreground whitespace-nowrap font-mono">
            ({formattedSize})
          </span>
        </button>
        {onRemove && (
          <Button
            size="icon-xs"
            variant="outline"
            className="hover:bg-destructive/10 hover:text-destructive rounded-[calc(var(--radius)-3px)]"
            onClick={onRemove}
            aria-label={`Remove ${name}`}
          >
            <X />
          </Button>
        )}
      </div>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      className={`h-auto py-1 px-2 gap-1 text-xs border border-border rounded-md bg-card hover:bg-muted/50 ${className}`}
      onClick={onClick}
      title={`Click to preview ${name}`}
    >
      <FileText className="h-3 w-3 text-muted-foreground" />
      <span className="font-medium truncate max-w-24">{name}</span>
      <span className="text-muted-foreground whitespace-nowrap font-mono">
        ({formattedSize})
      </span>
    </Button>
  );
}
